import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import classNames from 'classnames';

// 🧼 Премахва всички видове citation тагове
const stripCitations = (text) => {
  // [16:0+SomeFile.docx]
  text = text.replace(/\[\d+:\d+\+.*?\]/g, "");
  //   ,   ,  
  text = text.replace(/【\d+:\d+†[^】]+】/gi, "");
  return text.trim();
};

export default function ChatMessage({ message, role, username }) {
  const isUser = role === "user";

  return (
    <div className="my-4 px-4 w-full flex justify-center">
      <div className="w-full flex max-w-2xl">
        <div
          className={classNames(
            "whitespace-pre-wrap text-base p-4 rounded-xl",
            {
              "bg-[#140D4F] text-white ml-auto text-left": isUser,
              "bg-gray-100 text-black text-left": !isUser,
            }
          )}
        >
          <div className="text-xs font-semibold text-slate-300 mb-1">
            {isUser ? username : "DiagCodeAI"}
          </div>
          <Markdown
            className="markdown"
            remarkPlugins={[remarkGfm]}
            components={{
              img: ({ node, ...props }) => (
                <img
                  {...props}
                  alt={props.alt || "DiagCode repair diagram"}
                  className="max-w-full max-h-[500px] rounded-lg shadow-md my-2 cursor-pointer"
                  onClick={() => window.open(props.src, "_blank")}
                  title="Click to open in new tab"
                />
              ),
            }}
          >
            {stripCitations(message)}
          </Markdown>
        </div>
      </div>
    </div>
  );
}
